import {FC, useEffect, useContext, useState, useLayoutEffect} from "react";
import { useParams, useSearchParams } from "react-router-dom";

import TerritoriesFilter from "src/components/manufacturer/territoriesFilter";
import CustomComponentCaseVolumeTerritories from "src/components/manufacturer/customComponentCaseVolumeTerritories";
import CustomPieChart from "src/components/manufacturer/customPieChart";
import CaseDetail from "src/components/manufacturer/caseDetail";
import CustomProviderPractice from "src/components/manufacturer/customProviderPractice";
import CustomPracticeListing from "src/components/manufacturer/customPracticeListing";
import AuthMaunfacturerSubHeader from "src/components/manufacturer/authManufacturerSubHeader";
import FooterText from "src/components/footerText";

import useFetch from "src/hooks/useFetch";
import { ToastContext } from "src/context/toastContext";
import { LoaderContext } from "src/context/loaderContext";
import { MANUFACTURER_DEFAULT_END_DATE, MANUFACTURER_DEFAULT_START_DATE } from "src/constants/manufacturer";

import { TerritoriesSearchProps } from "src/components/manufacturer/territoriesFilter/types";
import { APIEndpoints } from "src/types/apiTypes";
import { ToastTypes } from "src/types";
import { StatisticsApiResponse } from "../manufacturer/types";
import { AuthContext } from "src/context/authContext";
//import { AuthContext } from "src/context/authContext";



const Territory: FC = (): JSX.Element => {
  const { showToast } = useContext(ToastContext);
  const { userData } = useContext(AuthContext);
  
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const [searchParams] = useSearchParams();
  const { id } = useParams();
  const [queryParams,changeQueryParams] = useState({
    start_date: searchParams.get('start_date') || MANUFACTURER_DEFAULT_START_DATE,
    end_date: searchParams.get('end_date') || MANUFACTURER_DEFAULT_END_DATE,
    period: searchParams.get('period') || "day",
    filter: searchParams.get('filter') || "",
    time: searchParams.get('time') || "",
    type: "",
    role:searchParams.get('role') || userData?.ref_type || "",
    id:Number(searchParams.get('id')) || Number(id),
    case_id: "",
    search_str: searchParams.get("search_str") || "",
    p_id: Number(searchParams.get('id')) || 0,
    age_group: searchParams.get("age_group") || "all",
  });




  const { data: statisticsData, error: statisticsError, mutate: getStatsData } = 
    useFetch<StatisticsApiResponse>(APIEndpoints.MANUFACTURE_STATISTICS, queryParams);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => setLoader(), [])

  useEffect(() => {
    if (statisticsData || statisticsError) {
      hideLoader();
      if (statisticsData && statisticsData.code === 200)
        showToast([statisticsData.message], ToastTypes.SUCCESS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statisticsData, statisticsError]);

  const updateQueryParamsAndCallAPI = (updatedQueries: TerritoriesSearchProps, isReset: boolean = false): void => {
    if (isReset) {
      changeQueryParams({
        start_date: MANUFACTURER_DEFAULT_START_DATE,
        end_date: MANUFACTURER_DEFAULT_END_DATE,
        period: "",
        filter: "",
        time: "",
        type: "",
        role: "",
        search_str:'',
        case_id:'',
        id: 0,
        p_id: 0,
        age_group: "all",
      });
    } else {
      changeQueryParams(updatedQueries);
    }

    setLoader()
    getStatsData({}, {}, updatedQueries);
  };



  return (
    <div className="container-fluid overflow-auto">
      {statisticsData && statisticsData.data && statisticsData.data.sub_header && (
        <AuthMaunfacturerSubHeader user={statisticsData.data.sub_header.user || undefined} territory={statisticsData.data.sub_header.territory || undefined} />
      )}

      <TerritoriesFilter
        defaultQueryParams={queryParams}
        updateQueryParams={updateQueryParamsAndCallAPI}
      />

      {statisticsData && (
        <CustomComponentCaseVolumeTerritories StatisticsObjectType={statisticsData.data} buttonShows={true} />
      )}

      <div className="row gx-2">
        <div className="col-12 col-lg-4 mb-3 d-flex flex-column flex-fill">
          {statisticsData && statisticsData.data && <CustomPieChart pieChartObject={statisticsData.data.top_payors} title={'Top 10 Payors'}/>}
        </div>
        <div className="col-12 col-lg-4 mb-3 d-flex flex-column flex-fill">
        {statisticsData && statisticsData.data && <CustomPieChart pieChartObject={statisticsData.data.mos} title={'Cases By Submission Mode'}/>}

        </div>
        <div className="col-12 col-lg-4 mb-3 d-flex flex-column flex-fill">
        {statisticsData && statisticsData.data && <CustomPieChart pieChartObject={statisticsData.data.diagnosis} title={'Diagnoses'}/>}
        </div>
      </div>

      <div className="row gx-2">
        <div className="col-12 col-md-6 mb-3">
          {statisticsData && statisticsData.data && statisticsData.data.practices && 
            <CustomPracticeListing providerPracticesList={statisticsData.data.practices} title={"Practices"}
              queryParams={queryParams}
            />
          }
        </div>
        <div className="col-12 col-md-6 mb-3">
          {statisticsData && statisticsData.data && statisticsData.data.prescribers &&
            <CustomProviderPractice providerPracticesList={statisticsData.data.prescribers} 
              title="Prescribers" queryParam={queryParams}
            />
          }
        </div>
      </div>

      <div className="row">
        {statisticsData && statisticsData.data && statisticsData.data.case_listing &&
          <CaseDetail baseUrl={`/statistics/${id}`} searchParams={queryParams} 
            CaseDetailListType={statisticsData.data.case_listing}
          />
        }
      </div>

      <FooterText footerType="black" />
    </div>
  );
};

export default Territory;
